<template>
	<div class="tb-price-block-disclaimer">
		Indicative model and pricing only. Due to extended wait times, the final vehicle we can offer you and its price are likely to&nbsp;be&nbsp;different.
	</div>
</template>
<script setup lang="ts">

</script>